<div class="main-container mat-app-background">
  @if (isMenuVisible) {
    <div class="header">
      <mat-toolbar class="primary mat-elevation-z2" color="primary">
        @if (backButtonVisible) {
          <a mat-icon-button class="backbutton" (click)="backButtonClicked()">
            <mat-icon>arrow_back</mat-icon>
          </a>
        }
        <ldw-logo></ldw-logo>
        <div class="doublelined">
          <div class="webdoku showIfEmpty">{{ webDokuName }}</div>
          <div class="infotext showIfEmpty">{{ infoText }}</div>
        </div>
        <span class="spacer"></span>
        @if (planningJobSelectionVisible) {
          <ldw-planning-job-select
            [initialValue]="selectedPlanningJob()?.name || ''"
            (jobChanged)="jobHasChanged($event)"
            />
        }
        <ldw-messages-button></ldw-messages-button>
        @if (searchButtonVisible) {
          <a
            mat-icon-button
            [routerLink]="menuService.cmdSearch.route"
            routerLinkActive="active-link"
            >
            <mat-icon>{{ menuService.cmdSearch.icon }}</mat-icon>
          </a>
        }
        @if (bookmarkService.bookmarksAvailable) {
          <ldw-document-bookmarks-button></ldw-document-bookmarks-button>
        }
        @if (loading$ | async) {
          <mat-progress-bar mode="indeterminate" class="loadingbar"></mat-progress-bar>
        }
      </mat-toolbar>
    </div>
  }

  <main class="main-outlet-container">
    <router-outlet></router-outlet>
  </main>

  @if (isMenuVisible) {
    <div class="footer">
      <ngx-bottom-nav class="bottombar" color="primary">
        @for (mitem of availableItems$ | async; track mitem) {
          <button
            ngx-bottom-nav
            label="{{ mitem.text }}"
            [routerLink]="mitem.route"
            >
            <mat-icon ngxBottomNavIcon>{{ mitem.icon }}</mat-icon>
          </button>
        }
        @if (isWebDokuAvailable) {
          <button ngx-bottom-nav [label]="'Info'" (click)="openInfoBottomSheet()">
            <mat-icon ngxBottomNavIcon>info</mat-icon>
          </button>
        }
        <button ngx-bottom-nav [label]="menuService.cmdUser.text" (click)="openUserBottomSheet()">
          <mat-icon ngxBottomNavIcon>{{ menuService.cmdUser.icon }}</mat-icon>
        </button>
      </ngx-bottom-nav>
    </div>
  }
</div>
